import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
export default [{
  path: '/graduation/index',
  alias: '/huangshan/index',
  name: ROUTE_NAME.HUANGSHAN_INDEX,
  meta: {
    title: '毕业丽江行',
    scrollBehavior: 'top',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "huangshan" */
      '@/pages/huangshan/index.vue'),
      loading: Loading
    };
  }
}, {
  path: '/graduation/info',
  alias: '/huangshan/info',
  name: ROUTE_NAME.HUANGSHAN_INFO,
  meta: {
    title: '填写报名资料',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "huangshan" */
      '@/pages/huangshan/info.vue'),
      loading: Loading
    };
  }
}];